import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const SearchIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.522 2C13.6758 2 17.043 5.36752 17.043 9.521C17.043 11.4181 16.3409 13.1513 15.1823 14.4748L21.8531 21.1465C22.0483 21.3417 22.0483 21.6583 21.853 21.8536C21.6578 22.0488 21.3412 22.0488 21.1459 21.8535L14.4754 15.182C13.1522 16.3413 11.4192 17.044 9.522 17.044C5.36803 17.044 2 13.6753 2 9.521C2 5.36769 5.36802 2 9.522 2ZM9.522 3C5.92029 3 3 5.92 3 9.521C3 13.1231 5.92035 16.044 9.522 16.044C13.1234 16.044 16.043 13.1233 16.043 9.521C16.043 5.91979 13.1235 3 9.522 3Z'
      />
    </svg>
  );
};
